<template>
  <el-form-item
    :label="title"
    :rules="[{required: isRequire, message: 'Please enter', trigger: 'blur'}]"
  >
    <el-input
      v-model="value"
      :placeholder="placeholder"
      :autofocus="focus"
      :autocomplete="autocomplete"
      :style="{ width: width + 'px' }"
      :disabled="disabled"
      @keyup.enter.native="handleSearch"
    ></el-input>
  </el-form-item>
</template>

<script>
import { parse, save } from '../providers/store-parser'
import { mapActions } from 'vuex'

export default {
  name: 'InputBasicText',
  props: {
    title: {
      type: String,
      required: false
    },
    getter: {
      type: String,
      required: true
    },
    setter: {
      type: String,
      required: true
    },
    defaultValue: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    focus: {
      type: Boolean,
      default: false
    },
    autocomplete: {
      type: String,
      default: 'off'
    },
    width: {
      type: Number,
      default: 200
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isRequire: {
      type: Boolean,
      default: false
    }
  },
  created () {
    if (this.defaultValue) {
      save(this.setter, this.defaultValue)
    }
  },
  computed: {
    value: {
      get () {
        return parse(this.getter) || this.defaultValue
      },
      set (val) {
        save(this.setter, val)
      }
    }
  },
  methods: {
    ...mapActions({
      search: 'search/search'
    }),
    async handleSearch () {
      this.bus.$emit('new-search')
      await this.search()
      this.bus.$emit('data-refresh')
    }
  },
  inject: ['bus']
}
</script>
